import React from 'react';
import { string } from 'prop-types';
import { GridToolbarFilterButton } from '@mui/x-data-grid-pro';
import { useTheme } from '@mui/material/styles';
import toolbarButtonStyles from './utlils/toolbarButtonStyles';
import useMosaicTranslation from '../internals/i18n/useMosaicTranslation';
const SovosDataGridToolbarFilterButton = _ref => {
  let {
    title
  } = _ref;
  const {
    t
  } = useMosaicTranslation();
  const theme = useTheme();
  return /*#__PURE__*/React.createElement(GridToolbarFilterButton, {
    slotProps: {
      button: {
        sx: toolbarButtonStyles(theme)
      },
      tooltip: {
        title: title || t('toolbar.filters')
      }
    }
  });
};
SovosDataGridToolbarFilterButton.propTypes = {
  title: string
};
export default SovosDataGridToolbarFilterButton;